// @shared

export type ShopCategory = "room" | "hats" | "accessories" | "outfits" | "pets" | "colors"

export type ShopRarity = "common" | "rare" | "epic" | "legendary"

/**
 * Слот, на который надевается косметика.
 * Один слот = один активный предмет одновременно.
 */
export type ShopSlot =
  | "hat" | "face" | "piercing" | "neck" | "back" | "outfit"
  | "outerwear" | "bottom" | "shoes" | "pet" | "palette"
  | "room_rug" | "room_light" | "room_seat" | "room_wall"
  | "room_wallpaper" | "room_bed" | "room_desk" | "room_desk_chair"
  | "room_computer" | "room_shelf" | "room_cabinet"

export interface ShopItem {
  id: string
  category: ShopCategory
  slot: ShopSlot
  title: string
  description: string
  emoji: string
  price: number
  rarity: ShopRarity
  isNew?: boolean
  /** только для colors */
  paletteSkin?: string
  paletteHair?: string
  paletteClothes?: string
}

export interface ShopItemDto extends ShopItem {
  owned: boolean
  equipped: boolean
}

export interface ShopStateDto {
  coins: number
  items: ShopItemDto[]
  ownedIds: string[]
  /** id экипированных предметов (по одному в совместимый слот) */
  equippedIds: string[]
  authorized: boolean
}

const OUTFIT_PART_SLOTS: ShopSlot[] = ["outerwear", "bottom", "shoes"]

/**
 * Полный костюм и отдельные части одежды взаимоисключаются. Остальные слоты
 * независимы: например, кольцо в нос можно носить одновременно с очками.
 */
export function conflictingShopSlots(slot: ShopSlot): ShopSlot[] {
  if (slot === "outfit") return [slot, ...OUTFIT_PART_SLOTS]
  if (OUTFIT_PART_SLOTS.includes(slot)) return [slot, "outfit"]
  return [slot]
}

export const RARITY_LABEL: Record<ShopRarity, string> = {
  common: "Обычное",
  rare: "Редкое",
  epic: "Эпическое",
  legendary: "Легендарное",
}

export const RARITY_COLOR: Record<ShopRarity, string> = {
  common: "#9CA3B8",
  rare: "#3F8EE6",
  epic: "#A855F7",
  legendary: "#F5A524",
}

export const CATEGORY_LABEL: Record<ShopCategory, string> = {
  room: "Для комнаты",
  hats: "Шапки",
  accessories: "Аксессуары",
  outfits: "Наряды",
  pets: "Питомцы",
  colors: "Палитры",
}

export const CATEGORY_ICON: Record<ShopCategory, string> = {
  room: "▦",
  hats: "🧢",
  accessories: "🕶️",
  outfits: "👕",
  pets: "🐾",
  colors: "🎨",
}
